import { AppButton, AppTextDifference } from 'components';
import * as AppPics from 'assets/images';
import useClassesList from 'hooks/API/GET/useClassesList';
import { Fragment, useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { HiPencil } from 'react-icons/hi';
import { BiPaperPlane } from 'react-icons/bi';
import useDebounce from 'hooks/useDebounce';
import QuizDeleteModal from './manage/ClassDeleteModal';
import ChooseSubjectModal from './manage/ChooseSubjectModal';
import { AiFillCaretDown, AiFillCaretUp, AiOutlineDelete } from 'react-icons/ai';
import { FcPlus } from 'react-icons/fc';
import { useQueryClient } from 'react-query';
import { FetchContext } from 'context/FetchContext';
import { TabContent, TabPane, Nav, NavItem } from 'reactstrap';
import classnames from 'classnames';
import ClassDropDownMenu from './ClassDropDownMenu';
import { UserContext } from 'context/UserContext';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import { useHistory } from 'react-router-dom';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import TablePaginate from 'components/Paginate';

function ManageClass() {
  const history = useHistory();
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const { userPermissions = {} } = useContext(UserContext);
  const [viewType, handleViewType] = useState('grid');
  const [search, handleSearch] = useState('');
  const [params, setParams] = usePaginateDefaults();
  const [deleteClassModal, handleDeleteClassModal] = useState(
    Object.assign({}, DELETE_CLASS_MODAL_CONFIG)
  );
  const [chooseSubjectModal, handleChooseSubjectModal] = useState(
    Object.assign({}, DELETE_CHOOSE_SUBJECT_MODAL_CONFIG)
  );
  // State for current active Tab
  const [currentActiveTab, setCurrentActiveTab] = useState('1');

  // Toggle active state for Tab
  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  const searchKeyword = useDebounce(search, 1000);

  const {
    isLoading,
    data: tableData,
    isError,
  } = useClassesList({
    enabled: true,
    configs: { params: { ...params, keyword: searchKeyword, status: 1 } },
  });
  const { meta: { page = 1, total } = {} } = tableData?.data ?? {};
  const [open, setOpen] = useState([]);
  useEffect(() => {
    if (tableData && tableData.data.length > 0 && open.length === 0) {
      handleViewType('grid');
      const hideSpecializationOnInit = Array.from(
        { length: (tableData.data && tableData.data.length) || 0 },
        () => true
      );
      setOpen(hideSpecializationOnInit);
    }
    return () => {};
  }, [isLoading, open.length, tableData]);
  const openSpecialization = (ind, value) => {
    const hideSpecializationOnInit = Array.from(
      { length: (tableData.data && tableData.data.length) || 0 },
      () => true
    );
    const currentObj = hideSpecializationOnInit;
    currentObj[ind] = value;
    setOpen(currentObj);
  };

  function fetchPlans(classID) {
    return privateFetch.get(`/v1/admin/class/${classID}/plan`).then((res) => res.data);
  }
  function handleChangeViewType(e) {
    // console.log(viewType);
    // console.log(e);
    handleViewType(e);
  }

  return (
    <Fragment>
      <QuizDeleteModal
        modalConfig={deleteClassModal}
        closeModal={() => handleDeleteClassModal(Object.assign({}, DELETE_CLASS_MODAL_CONFIG))}
      />
      <ChooseSubjectModal
        modalConfig={chooseSubjectModal}
        closeModal={() =>
          handleChooseSubjectModal(Object.assign({}, DELETE_CHOOSE_SUBJECT_MODAL_CONFIG))
        }
      ></ChooseSubjectModal>
      <div className="mainWraper coursetabsection">
        <div className="tab">
          {/* <ul className="tab__menu">
            <li className="active">Recent Classes</li>
            <li>All Classes</li>
            <li>Draft Classes</li>
            <li>Deactivated</li>
            <li>Archived</li>
          </ul> */}
          <Nav tabs className="tab__menu">
            <li className="back">
              <button className="btn-back" onClick={() => history.push('/curriculum')}>
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
            <NavItem
              className={classnames({
                active: currentActiveTab === '1',
              })}
              onClick={() => {
                toggle('1');
              }}
            >
              Classes
            </NavItem>
            <NavItem
              className={classnames({
                active: currentActiveTab === '2',
              })}
              onClick={() => {
                toggle('2');
              }}
            >
              All Classes
            </NavItem>
            <NavItem
              className={classnames({
                active: currentActiveTab === '3',
              })}
              onClick={() => {
                toggle('3');
              }}
            >
              Draft Classes
            </NavItem>
            <NavItem
              className={classnames({
                active: currentActiveTab === '4',
              })}
              onClick={() => {
                toggle('4');
              }}
            >
              Deactivated
            </NavItem>
            <NavItem
              className={classnames({
                active: currentActiveTab === '5',
              })}
              onClick={() => {
                toggle('5');
              }}
            >
              Archived
            </NavItem>
          </Nav>
          <TabContent activeTab={currentActiveTab}>
            {/* <AppTextDifference sourceText="'test'" newText="'Test'"></AppTextDifference> */}
            <TabPane tabId="1">
              <div className="tab__content">
                <div className="tab__content-actHead">
                  <AppBreadcrumbs
                    links={[
                      { label: 'Dashboard', to: '/dashboard' },
                      { label: 'Curriculum', to: '/curriculum' },
                    ]}
                    current="Classes"
                  />
                </div>
                <div className="tab__contentMenu">
                  <ul className="tab__contentMenu-list">
                    <li>
                      <button
                        onClick={() => {
                          handleChangeViewType('grid');
                        }}
                      >
                        <img src={AppPics.TabGridSvg} alt="" />
                        <span className="viewsettingtitle">Grid</span>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => {
                          handleChangeViewType('table');
                        }}
                      >
                        <img src={AppPics.TabListSvg} alt="" />
                        <span className="viewsettingtitle">List</span>
                      </button>
                    </li>
                    <li>
                      <button>
                        <img src={AppPics.TabFilterSvg} alt="" />
                        <span className="viewsettingtitle">Filter</span>
                      </button>
                    </li>
                  </ul>
                  <div className="mainHeader__search">
                    <input
                      className="mainHeader__searchInput"
                      placeholder="Search for something all over edpodia…"
                      type="text"
                      onChange={(event) => handleSearch(event.target.value)}
                    />
                    <span className="mainHeader__searchBtn">
                      <img src={AppPics.TopMenuSearchSvg} alt="" />
                    </span>
                  </div>
                  <div>
                    {userPermissions?.class?.canCreateNew && (
                      <Link to="/manage/classes/add">
                        <button className="btn-left-content add">New class</button>
                      </Link>
                    )}
                  </div>
                </div>
                <div className="tab__contentBody">
                  <h2 className="prime-head forSlider boldtitle"> Classes</h2>
                  {viewType === 'grid' && (
                    <div className="slider">
                      {/* <div className="sliderBtns">
                    <button className="btn-circle"></button>
                  </div> */}
                      {isLoading ? (
                        'Loading...'
                      ) : isError ? (
                        'Failed to load data'
                      ) : tableData?.data?.result?.length > 0 ? (
                        <div className="sliderSec">
                          {tableData?.data?.result?.map((result, index) => {
                            return (
                              <Fragment key={result._id}>
                                <div className="sliderSec-box">
                                  <img
                                    className="sliderSec-boxImg"
                                    src={
                                      result?.courseImageUrlFull || 'https://picsum.photos/300/400'
                                    }
                                    alt=""
                                  />
                                  <div className="sliderSec-boxHead">
                                    <h2>{result.name}</h2>
                                  </div>
                                  <div className="sliderSec-boxBtns classdetail">
                                    {result.parentClassName && (
                                      <button
                                        className="btn-plane btn-slide-warp mr-4"
                                        type="button"
                                        role={'definition'}
                                        title={result?.parentClassName}
                                      >
                                        {result.parentClassName}
                                      </button>
                                    )}

                                    <button
                                      type="button"
                                      role={'definition'}
                                      title={result?.es?.name}
                                      className="btn-plane green btn-slide-warp"
                                    >
                                      {result?.es?.name}
                                    </button>
                                    {result?.est?.key === 'in' && (
                                      <img
                                        className="country_tag"
                                        src={AppPics.IndiaFlagSvg}
                                        alt=""
                                      />
                                    )}
                                    {result?.est?.key === 'uk' && (
                                      <img className="country_tag" src={AppPics.UkFlagSvg} alt="" />
                                    )}
                                  </div>
                                  <div className="sliderSec-boxMore">
                                    <ClassDropDownMenu classDetails={result} />

                                    {/* {!result.isParentClass &&
                                      (!result.specializations ||
                                        (!result.specializations.length && (
                                          <button
                                            className="btn-right-content tool"
                                            onClick={() =>
                                              handleChooseSubjectModal(() => ({
                                                show: true,
                                                data: {
                                                  subjects: result?.subjects,
                                                  id: result._id,
                                                },
                                              }))
                                            }
                                          >
                                            Manage
                                          </button>

                                          // <Link
                                          //   to={`/manage/classes/${result._id}/chapters`}
                                          //   className="actions-icons mx-2"
                                          // >
                                          //   <button className="btn-right-content tool">
                                          //     Manage
                                          //   </button>
                                          // </Link>
                                        )))} */}
                                  </div>
                                </div>
                              </Fragment>
                            );
                          })}
                        </div>
                      ) : (
                        'No records found'
                      )}
                      {/* <div className="sliderBtnsRight">
                    <button className="btn-circle next"></button>
                  </div> */}
                    </div>
                  )}
                  {viewType === 'table' && (
                    <div className="tableWrap">
                      {/* <div className="tableWrap__header">
                    <div>
                      <AppTextField
                        inputProps={{
                          value: search,
                          placeholder: 'Type to search...',
                          onChange: (event) => handleSearch(event.target.value),
                        }}
                        labelProps={{
                          label: '',
                        }}
                      />
                    </div>
                  </div> */}

                      <div className="table-responsive">
                        <table className="table tableWrap__table">
                          <thead className="thead-light __appTheadColor">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col"></th>
                              <th scope="col" className="w15">
                                Name
                              </th>
                              <th scope="col" className="w15">
                                Unique key{' '}
                              </th>
                              <th scope="col" className="w15">
                                ES
                              </th>
                              <th scope="col" className="w15">
                                Subject
                              </th>
                              <th scope="col" className="w15">
                                Status
                              </th>
                              <th scope="col" className="align-center">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          {isLoading ? (
                            'Loading...'
                          ) : isError ? (
                            'Failed to load data'
                          ) : tableData?.data?.result?.length > 0 ? (
                            <tbody>
                              {tableData?.data?.result?.map((result, index) => {
                                return (
                                  <Fragment>
                                    <tr key={result._id}>
                                      <th scope="row">{index + 1}</th>
                                      <th>
                                        {result.specializations &&
                                          result.specializations.length > 0 && (
                                            <AppButton
                                              className="actions-icons mx-2 text-danger"
                                              onClick={() =>
                                                openSpecialization(index, !open[index])
                                              }
                                            >
                                              {open[index] && <AiFillCaretDown />}
                                              {!open[index] && <AiFillCaretUp />}
                                            </AppButton>
                                          )}
                                      </th>
                                      <td>{result.name}</td>
                                      <td>{result.key}</td>
                                      <td>{result?.es?.name}</td>
                                      <td>{result?.subjectsAvailed}</td>
                                      <td>{result?.status}</td>
                                      <td className="align-center">
                                        {/* <Link
                              to={`/manage/topics/${result?.topic?._id}/quiz/${result._id}/questions`}
                              className="actions-icons mx-2 text-success"
                            >
                              <AiOutlineFileDone />
                            </Link> */}
                                        <Link
                                          to={`/manage/classes/edit/${result?._id}`}
                                          className="actions-icons mx-2"
                                        >
                                          <HiPencil />
                                        </Link>
                                        <AppButton
                                          className="actions-icons mx-2 text-danger"
                                          onClick={() =>
                                            handleDeleteClassModal(() => ({
                                              show: true,
                                              data: { classID: result?._id },
                                            }))
                                          }
                                        >
                                          <AiOutlineDelete />
                                        </AppButton>
                                        {/* <Link
                                          to={`/manage/classes/${result._id}/chapters`}
                                          className="actions-icons mx-2"
                                        >
                                          <FcPlus />
                                        </Link> */}
                                        {/* {result?.specializations?.length === 0 && (
                                          <button
                                            className="actions-icons mx-2"
                                            onClick={() =>
                                              handleChooseSubjectModal(() => ({
                                                show: true,
                                                data: {
                                                  subjects: result?.subjects,
                                                  id: result._id,
                                                },
                                              }))
                                            }
                                          >
                                            <FcPlus />
                                          </button>
                                          // <Link
                                          //   to={`/manage/classes/${result._id}/chapters`}
                                          //   className="actions-icons mx-2"
                                          // >
                                          //   <FcPlus />
                                          // </Link>
                                        )} */}
                                      </td>
                                    </tr>
                                    {open[index] &&
                                      result.specializations &&
                                      result.specializations.length > 0 && (
                                        <tr>
                                          <td colSpan="8">
                                            <table className="table">
                                              <thead className="thead-light __appTheadColor">
                                                <tr>
                                                  <th scope="col">Name</th>
                                                  <th scope="col">key </th>
                                                  <th scope="col">ES</th>
                                                  <th scope="col">Subject</th>

                                                  <th scope="col">Status</th>
                                                  <th scope="col">Actions</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {result.specializations.map((sub, subIdx) => {
                                                  return (
                                                    <tr key={sub._id}>
                                                      <td>{sub.name}</td>
                                                      <td>{sub.key}</td>
                                                      <td>{sub?.es?.name}</td>
                                                      <td>
                                                        {sub?.subjects &&
                                                          sub?.subjects.length > 0 &&
                                                          sub?.subjects.map((subject) => {
                                                            return (
                                                              <span>{subject.subject.name}, </span>
                                                            );
                                                          })}
                                                      </td>
                                                      <td>{sub?.status}</td>
                                                      <td>
                                                        <Link
                                                          to={`/manage/classes/${sub._id}/plans`}
                                                          className="actions-icons mx-2"
                                                          title="Plan"
                                                          onMouseEnter={() => {
                                                            queryClient.prefetchQuery(
                                                              ['class-subject-plans', sub._id],
                                                              () => fetchPlans(sub._id),
                                                              { staleTime: Infinity }
                                                            );
                                                          }}
                                                        >
                                                          <BiPaperPlane />
                                                        </Link>
                                                        <Link
                                                          to={`/manage/classes/edit/${sub?._id}`}
                                                          className="actions-icons mx-2"
                                                        >
                                                          <HiPencil />
                                                        </Link>
                                                        <AppButton
                                                          className="actions-icons mx-2 text-danger"
                                                          onClick={() =>
                                                            handleDeleteClassModal(() => ({
                                                              show: true,
                                                              data: { classID: sub?._id },
                                                            }))
                                                          }
                                                        >
                                                          <AiOutlineDelete />
                                                        </AppButton>
                                                        {sub?.specializations?.length === 0 && (
                                                          <Link
                                                            to={`/manage/classes/${sub._id}/chapters`}
                                                            className="actions-icons mx-2"
                                                          >
                                                            <FcPlus />
                                                          </Link>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  );
                                                })}
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      )}
                                  </Fragment>
                                );
                              })}
                            </tbody>
                          ) : (
                            'No records found'
                          )}
                        </table>
                      </div>
                      {/* <div className="row">
            <div>
              <span>Current Page: {paginate}</span>
              <button
                type="button"
                onClick={() => handlePaginate((old) => Math.max(old - 1, 0))}
                disabled={paginate === 0}
              >
                Prev
              </button>
              <button
                onClick={() => handlePaginate((old) => old + 1)}
                // Disable the Next Page button until we know a next page is available
                disabled={total === paginate}
              >
                Next Page
              </button>
            </div>
          </div> */}
                    </div>
                  )}
                </div>
              </div>
            </TabPane>
          </TabContent>
        </div>
      </div>
      {/* <div className="mainWraper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-6">
              <h2 className="prime-head p-0">Manage Class</h2>
              
            </div>
            <div className="col-6 text-right">
              <Link to="/manage/classes/add">
                <AppButton variantClass="btn-plane g--tint prime-head-btn ">+ Add Class</AppButton>
              </Link>
            </div>
          </div>
        </div>
      </div> */}

      <TablePaginate
        maxCount={total}
        currentPage={page}
        defaultLimit={params.limit}
        setPage={(page) => setParams((x) => ({ ...x, page }))}
        handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
      />
    </Fragment>
  );
}

const DELETE_CLASS_MODAL_CONFIG = {
  show: false,
  data: {
    id: null,
  },
};

const DELETE_CHOOSE_SUBJECT_MODAL_CONFIG = {
  show: false,
  data: {
    subjects: [],
    id: null,
  },
};

export default ManageClass;
